import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Arrow } from '../../../assets/img/home/ArrowRight.svg';
import { useInput } from '../../../hooks';
import { useAccountLoginMutation, useLoginMutation } from '../../../services/api';
import { extractErrorDetail } from '../../common';
import Button from '../Button/Button';
import Form from '../Form';
import { Modal } from '../Modal';
import { EmailValidationModal } from '../Modals/EmailValidationModal';
import { ErrorModal } from '../Modals/ErrorModal';
import { ForgotPasswordModal } from '../Modals/ForgotPasswordModal';
import PasswordInput from '../PasswordInput';
import TextInput from '../TextInput';


interface TotpModalProps {
    user: string,
    password: string,
    isOpen: boolean,
    onClose: () => void,
}

export function TotpModal({ user, password, isOpen, onClose }: TotpModalProps) {
    const [login, { isLoading }] = useLoginMutation();
    const [accountLogin] = useAccountLoginMutation();
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [token, setToken] = useState('');

    useEffect(() => {
        setError('');
        setToken('');
    }, [isOpen]);

    return (
        <Modal className={'popup_message'} isOpen={isOpen} onClose={() => onClose()}>
            <h2 className="popup__heading">
                <Trans>
                    Введите код подтверждения
                </Trans>
            </h2>
            <TextInput autoFocus value={token} onChange={(e) => setToken(e.target.value)} />
            <div className="form__input-error-message">{error}</div>
            <div className="form__submit" style={{ marginTop: '20px' }}>
                <Button disabled={isLoading} onClick={() => {
                    login({ username: user, password: password, token }).unwrap().then((data) => {
                        if (!data.pd_agreement) {
                            window.location.pathname !== '/agreement' && navigate('/agreement');
                            return;
                        }
                        const jwt = data.access.split('.')[1];
                        const jwtDecoded = JSON.parse(atob(jwt));
                        if (jwtDecoded.accound_id) {
                            // window.location.reload();
                            window.location.pathname === '/login' && navigate('/');
                            return;
                        }

                        if (data.accounts?.length === 1 || data.accounts?.length === 2) {
                            accountLogin({
                                refresh: data.refresh,
                                username: user,
                                account: data.accounts?.at(data.accounts.length - 1)?.id.toString() || ''
                            }).unwrap().then((z) => {
                                if (!z.agr_offer) {
                                    window.location.pathname !== '/agreement' && navigate('/agreement');
                                    return;
                                }
                                // window.location.reload();
                                window.location.pathname === '/login' && navigate('/');
                            }).catch((e) => {
                                setError(extractErrorDetail(e));
                                alert(e);
                            });
                        } else {
                            // window.location.reload();
                            window.location.pathname === '/login' && navigate('/');
                        }
                    }).catch((e) => {
                        console.log(e);
                        setError(extractErrorDetail(e));
                    });
                }}>
                    <Trans>Send</Trans>
                </Button>
            </div>
        </Modal >
    );
}

function HomeAuth() {
    const [login, { isLoading }] = useLoginMutation();
    const [accountLogin] = useAccountLoginMutation();
    const [empty, setEmpty] = useState<boolean>();
    const emptyUsername = t('Enter Email');
    const emptyPassword = t('Enter password');

    const navigate = useNavigate();
    const [username, resetUsername] = useInput('');
    const [password, resetPassword] = useInput('');
    const [error, setError] = useState('');
    const [showRegistration, setShowRegistration] = useState(false);
    const [showForgot, setShowForgot] = useState(false);
    const [showError, setShowError] = useState(false);
    const [showTotp, setShowTotp] = useState(false);
    const [modalErrorText, setModalErrorText] = useState('');

    function resetForm() {
        resetUsername();
        resetPassword();
    }

    function onLogin() {
        setError('');
        let isEmpty = false;
        if (!username.value) {
            isEmpty = true;
        }
        if (!password.value) {
            isEmpty = true;
        }
        setEmpty(isEmpty);
        if (isEmpty) {
            return;
        }
        login({ username: username.value, password: password.value }).unwrap().then((data) => {
            if (!data.pd_agreement) {
                window.location.pathname !== '/agreement' && navigate('/agreement');
                return;
            }
            const jwt = data.access.split('.')[1];
            const jwtDecoded = JSON.parse(atob(jwt));
            if (jwtDecoded.accound_id) {
                resetForm();
                // window.location.reload();
                window.location.pathname === '/login' && navigate('/');
                return;
            }

            if (data.accounts?.length === 1 || data.accounts?.length === 2) {
                accountLogin({
                    refresh: data.refresh,
                    username: username.value,
                    account: data.accounts?.at(data.accounts.length - 1)?.id.toString() || ''
                }).unwrap().then((z) => {
                    if (!z.agr_offer) {
                        window.location.pathname !== '/agreement' && navigate('/agreement');
                        return;
                    }
                    resetForm();
                    // window.location.reload();
                    window.location.pathname === '/login' && navigate('/');
                }).catch((e) => {
                    if (e.status === 418) {
                        console.log(e);
                    } else {
                        alert(e);
                    }
                    setError(e.message);
                });
            } else {
                resetForm();
                // window.location.reload();
                window.location.pathname === '/login' && navigate('/');
            }
        }).catch((e) => {
            if (e) {
                if (e.status === 423) {
                    const reason = e.data?.response?.status?.detail;
                    setModalErrorText(`Уважаемый пользователь! Доступ к сайту временно приостановлен.\n ${reason ? 'Причина: ' + reason : ''}.`);
                    setShowError(true);
                } else if (e.status === 418) {
                    setShowTotp(true);
                } else {
                    const detail = e.data?.detail;
                    if (detail) {
                        setError(t(detail));
                    } else {
                        setError(t(extractErrorDetail(e)));
                    }
                }
            } else {
                setError(t(e.message));
            }
        });
    }

    return (
        <div className="home-auth" data-testid="home-auth">
            <EmailValidationModal isOpen={showRegistration} onClose={() => setShowRegistration(false)} />
            <ForgotPasswordModal isOpen={showForgot} onClose={() => setShowForgot(false)} />
            <TotpModal user={username.value} password={password.value} isOpen={showTotp} onClose={() => setShowTotp(false)} />
            <ErrorModal isOpen={showError} onClose={() => setShowError(false)} title={''} content={modalErrorText} />

            <div className="home-auth__login">
                <div className="home-auth__login-heading">
                    <Trans>Log In</Trans>
                </div>
                <Form action="#login" className="home-auth__login-form">
                    <div className={'form__item home-auth__login-item _input' + ((error || (empty && !username.value)) ? ' _error' : '')}>
                        <input {...username} name="username" type="text" className={'form__input' + ((error || (empty && !username.value)) ? ' _error' : '')} required placeholder={t('Email')} />
                        {(empty && !username.value) && <div className="form__input-error-message">{emptyUsername}</div>}
                        {error && <div className="form__input-error-message">{error}</div>}
                    </div>
                    <div
                        className={'form__item home-auth__login-item _input' + ((error || (empty && !password.value)) ? ' _error' : '')}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                onLogin();
                            }
                        }}>
                        <PasswordInput {...password} name="password" className={((error || (empty && !password.value)) ? ' _error' : '')} required placeholder={t('Password')} />
                        {(empty && !password.value) && <div className="form__input-error-message">{emptyPassword}</div>}
                    </div>
                    <div className="form__item home-auth__login-item _submit">
                        <Button
                            className="_bd"
                            name="sign_in"
                            disabled={isLoading}
                            onClick={(e) => {
                                e.preventDefault();
                                onLogin();
                            }}
                        >
                            <Trans>Sign in</Trans>
                        </Button>
                    </div>
                    <div className="home-auth__login-item _forgot _js-forgot-pass" onClick={() => setShowForgot(true)}>
                        <Trans>Forgot your password</Trans>?
                    </div>
                </Form>
            </div>
            <div className="home-auth__reg">
                <a href="#register" className="btn _js-register" onClick={(e) => {
                    e.preventDefault();
                    setShowRegistration(true);
                }}>
                    <span className="btn__icon _right">
                        <Trans>Sign Up</Trans>
                        <Arrow />
                    </span>
                </a>
            </div>
        </div>
    )
}

export default HomeAuth;